export default "__VITE_ASSET__40323034__"